module.exports = __webpack_public_path__ + "img/peel_1.afb84ece.jpg";